import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const CompanyProfileTabsStyledContainer = styled(Box)`
  .root-company-profile-tabs {
    &__tab {
      color: #383838;
    }
    &__wrapper {
      margin-top: 30px;
    }
  }
`;

export { CompanyProfileTabsStyledContainer };
